<div [formGroup]="senderService.senderForm">
  <div class="row">
    <div class="col-12">
      <nz-form-item>
        <nz-form-label class="text-muted mb-0">
          Режим парсинга
          <span class="badge badge-sm badge-success ml-3">бесплатно</span>
          <ng-template [ngIf]="senderService.parseType === 2 && !interfaceService.isLeadsDomain">
            <i-feather name="plus"></i-feather>
            <span class="badge badge-sm badge-success">{{senderService.messagePrice}}₽/сообщение</span>
          </ng-template>
        </nz-form-label>
        <nz-form-control>
          <nz-radio-group
            [(ngModel)]="senderService.parseType"
            [ngModelOptions]="{standalone: true}" (ngModelChange)="setTypeChange($event)"
          >
            <label placement="top" [tooltip]="helpTypeOnlyDownload" nz-radio-button [nzValue]="1">
              <i-feather name="download-cloud"></i-feather>
              Только скачать
            </label>
            <label placement="top" [tooltip]="helpTypeSndSend" nz-radio-button [nzValue]="2">
              <i-feather name="send"></i-feather>
              Отправлять сообщение
            </label>
          </nz-radio-group>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-lg-6">
      <nz-form-item class="mb-0">
        <!--target="_blank" class="text-muted text-underline" href="https://tgstat.ru/"-->
        <nz-form-label class="text-muted mb-0">Ссылка на группу/канал для парсинга |&nbsp;
          <a (click)="modalService.openModal('FaqParseComponent', {});" class="text-info text-underline pointer">где взять?</a>
        </nz-form-label>
        <nz-form-control [nzValidateStatus]="senderService.checkChatStatus"
                         nzWarningTip="Вставьте ссылку на канал/группу/чат"
                         nzHasFeedback [nzErrorTip]="senderService.errorChatDetail">
          <input nz-input formControlName="parsed_chat" id="parsed_chat"/>
        </nz-form-control>
      </nz-form-item>
    </div>
    <div *ngIf="senderService.senderForm.value?.parsed_chat?.length >= 3" class="col-12 col-12 col-lg-6">
      <div *ngIf="!senderService.loadedChatDetail" class="row mx-0 align-items-center mt-6">
        <div class="col-auto pr-0">
          <div class="avatar mr-5">
            <div class="avatar-icon text-white" [ngStyle]="{ 'background-color': '#c4c4c4' }">
              <div class="d-flex w-100 align-items-center justify-content-center">
                <i-feather name="message-square" class="icon-md"></i-feather>
              </div>
            </div>
          </div>
        </div>
        <div class="col pl-0">
          <div class="media-body overflow-hidden">
            <div class="mb-1">
              <nz-skeleton-element
                [style.width.px]="130"
                nzType="input"
                [nzActive]="true"
                [nzSize]="'small'"
              ></nz-skeleton-element>
              <div></div>
              <nz-skeleton-element
                [style.width.px]="100"
                nzType="input"
                [nzActive]="true"
                [nzSize]="'small'"
              ></nz-skeleton-element>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="senderService.loadedChatDetail && senderService.chatInfo?.chat?.type"
           class="row mx-0 align-items-center mt-6">
        <div class="col-auto pr-0">
          <app-avatar
            [id]="senderService.chatInfo.chat.id"
            [type]="senderService.chatInfo.chat.type"
            [avatar]="senderService.chatInfo.chat.avatar"
            [avatarFileId]="senderService.chatInfo.chat.avatar_file_id"
            [avatarFileUniqueId]="senderService.chatInfo.chat?.avatar_file_unique_id"
            [force]="true"
            [Service]="telegramService"
            class="avatar mr-5"
          ></app-avatar>
        </div>
        <div class="col pl-0">
          <h6 class="text-truncate mb-0 font-weight-bold">
            <span [innerHTML]="interfaceService.getChatTitle(senderService.chatInfo.chat,  senderService.chatInfo?.user)
                    | replaceEmojis: 'facebook':20:64"></span>
          </h6>
          <small *ngIf="senderService.chatInfo.chat?.members_count" class="text-muted">
            {{appService.declOfNum(senderService.chatInfo.chat?.members_count, ['# участник', '# участника', '# участников'])}}
          </small>
        </div>
      </div>
    </div>
  </div>
</div>
